import { CreditNoteDetailsPage } from 'CreditNotes/pages'

const CreditNoteDetailRoute = () => {
  return <CreditNoteDetailsPage />
}

export default CreditNoteDetailRoute
